/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import Header from '@features/header';
import { Route, Switch } from 'react-router-dom';
import { RouteErrorBoundary } from '@features/error';
import { AppLayout } from '../../layout/AppLayout';
import { AppRouteInterface, HydratedRouteInterface } from '@g17eco/types/routes';
import { AppHeader } from '@features/header/AppHeader';
import SDGAPLogo from '../../images/apps/SDGAP_logo.svg';
import { sdgGapRoutes } from './routes';
import { getHydratedRoutes } from '../../constants/routeComponents';

export const sdgapRouteEntry: HydratedRouteInterface = {
  id: 'sdgap_entry',
  label: 'Taxonomy',
  path: '/sdgap/:tool?/:type?/:code?',
  appPermissionId: 'app_sdgap',
  auth: true,
  exact: false,
  component: SdgapRoute,
}

const SdgAppRoute: AppRouteInterface = {
  appName: 'SD(G)AP',
  appIcon: SDGAPLogo,
  routes: Object.values(sdgGapRoutes)
}

const component = (props: any) => (
  <Header {...props} className={'responsivePage'}>
    <AppHeader appRoute={SdgAppRoute} route={sdgGapRoutes.SDGAP} />
  </Header>
);
const routes = getHydratedRoutes(sdgGapRoutes);

export function SdgapRoute() {
  return (
    <RouteErrorBoundary>
      <AppLayout Header={<Route path={'/sdgap'} component={component} />}>
        <Switch>
          <Route {...routes.SDGAP} />
          <Route {...routes.SDGAP_PRIMARY_CONNECTIONS} />
        </Switch>
      </AppLayout>
    </RouteErrorBoundary>
  );
}

